/* tslint:disable */
/* eslint-disable */
/**
 * Property Search API
 * Search properties and get aggregated info about areas.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PropertyTypeItem,
  PropertyTypeOptionDto,
  PropertyTypeTreeDto,
} from '../models/index';
import {
    PropertyTypeItemFromJSON,
    PropertyTypeItemToJSON,
    PropertyTypeOptionDtoFromJSON,
    PropertyTypeOptionDtoToJSON,
    PropertyTypeTreeDtoFromJSON,
    PropertyTypeTreeDtoToJSON,
} from '../models/index';

export interface PropertyTypeControllerListAllRequest {
    neighborhoodFilter?: string;
    cityFilter?: string;
    stateFilter?: string;
}

export interface PropertyTypeV2ControllerGetOptionsRequest {
    mlsSources?: Array<any>;
    canonical?: boolean;
}

export interface PropertyTypeV2ControllerGetTreeRequest {
    canonical?: boolean;
    mlsSources?: Array<any>;
}

/**
 * PropertyTypesApi - interface
 * 
 * @export
 * @interface PropertyTypesApiInterface
 */
export interface PropertyTypesApiInterface {
    /**
     * 
     * @param {string} [neighborhoodFilter] 
     * @param {string} [cityFilter] 
     * @param {string} [stateFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyTypesApiInterface
     */
    propertyTypeControllerListAllRaw(requestParameters: PropertyTypeControllerListAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyTypeItem>>>;

    /**
     */
    propertyTypeControllerListAll(requestParameters: PropertyTypeControllerListAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyTypeItem>>;

    /**
     * 
     * @param {Array<any>} [mlsSources] Filter options to those that apply to the given MLS sources. If not provided, options for all MLS sources will be returned.
     * @param {boolean} [canonical] If true, only return canonical options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyTypesApiInterface
     */
    propertyTypeV2ControllerGetOptionsRaw(requestParameters: PropertyTypeV2ControllerGetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyTypeOptionDto>>>;

    /**
     */
    propertyTypeV2ControllerGetOptions(requestParameters: PropertyTypeV2ControllerGetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyTypeOptionDto>>;

    /**
     * 
     * @param {boolean} [canonical] If true, only return canonical options.
     * @param {Array<any>} [mlsSources] Filter options to those that apply to the given MLS sources. If not provided, options for all MLS sources will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertyTypesApiInterface
     */
    propertyTypeV2ControllerGetTreeRaw(requestParameters: PropertyTypeV2ControllerGetTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyTypeTreeDto>>;

    /**
     */
    propertyTypeV2ControllerGetTree(requestParameters: PropertyTypeV2ControllerGetTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyTypeTreeDto>;

}

/**
 * 
 */
export class PropertyTypesApi extends runtime.BaseAPI implements PropertyTypesApiInterface {

    /**
     */
    async propertyTypeControllerListAllRaw(requestParameters: PropertyTypeControllerListAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyTypeItem>>> {
        const queryParameters: any = {};

        if (requestParameters['neighborhoodFilter'] != null) {
            queryParameters['neighborhoodFilter'] = requestParameters['neighborhoodFilter'];
        }

        if (requestParameters['cityFilter'] != null) {
            queryParameters['cityFilter'] = requestParameters['cityFilter'];
        }

        if (requestParameters['stateFilter'] != null) {
            queryParameters['stateFilter'] = requestParameters['stateFilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/property-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PropertyTypeItemFromJSON));
    }

    /**
     */
    async propertyTypeControllerListAll(requestParameters: PropertyTypeControllerListAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyTypeItem>> {
        const response = await this.propertyTypeControllerListAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async propertyTypeV2ControllerGetOptionsRaw(requestParameters: PropertyTypeV2ControllerGetOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PropertyTypeOptionDto>>> {
        const queryParameters: any = {};

        if (requestParameters['mlsSources'] != null) {
            queryParameters['mlsSources'] = requestParameters['mlsSources'];
        }

        if (requestParameters['canonical'] != null) {
            queryParameters['canonical'] = requestParameters['canonical'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v2/property-types/options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PropertyTypeOptionDtoFromJSON));
    }

    /**
     */
    async propertyTypeV2ControllerGetOptions(requestParameters: PropertyTypeV2ControllerGetOptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PropertyTypeOptionDto>> {
        const response = await this.propertyTypeV2ControllerGetOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async propertyTypeV2ControllerGetTreeRaw(requestParameters: PropertyTypeV2ControllerGetTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PropertyTypeTreeDto>> {
        const queryParameters: any = {};

        if (requestParameters['canonical'] != null) {
            queryParameters['canonical'] = requestParameters['canonical'];
        }

        if (requestParameters['mlsSources'] != null) {
            queryParameters['mlsSources'] = requestParameters['mlsSources'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v2/property-types/tree`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyTypeTreeDtoFromJSON(jsonValue));
    }

    /**
     */
    async propertyTypeV2ControllerGetTree(requestParameters: PropertyTypeV2ControllerGetTreeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PropertyTypeTreeDto> {
        const response = await this.propertyTypeV2ControllerGetTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
